import {
    IconDefinition
} from "@fortawesome/pro-light-svg-icons";
import FlowMode from "@/models/enums/flow-mode";

class MetricProcess {
    is2D = false;

    is3D = true;

    keyName: string;
    
    icon!: IconDefinition;

    isMagick = true;

    text!: string;

    is2DDone? = false;

    _2DAction?: () => void;

    is3DDone? = false;

    _3DAction?: () => void;

    actionText = 'Générez'

    visualisationLink?: string;

    constructor(keyName: string, flowMode: FlowMode, init?: Partial<Omit<MetricProcess, 'keyName'>>) {
        this.keyName = keyName;
        
        if (flowMode === FlowMode._2D3D) {
            this.is2D = true;
            this.is3D = false;
        }
        else if (flowMode === FlowMode._3D2D) {
            this.is2D = false;
            this.is3D = true;
        }

        Object.assign(this, init);
    }
}

export default MetricProcess;